__turbopack_context__.v({
  "heroCardWrapper": "heroCardList-module-scss-module__7lzmLG__heroCardWrapper",
  "leftCard": "heroCardList-module-scss-module__7lzmLG__leftCard",
  "rightCard": "heroCardList-module-scss-module__7lzmLG__rightCard",
});
